import React from "react";
import "../../App.css";

export default function Stats() {
  return (
    <div className="stats">
      <h1>
        Stats 2021 <br /> Coming Soon
      </h1>
    </div>
  );
}
